import { Drawer } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import React from "react";
import { localized } from "../../../state/i18n/i18n";
import "./notification-drawer.scss";
import NotificationList from "./notification-list";

const NotificationDrawer: React.FC = () => {
  return (
    <div className={"desktop"}>
      <Drawer variant="permanent" anchor="right">
        <div className="topContainer notifikationHeader notificationHeaderApp">
          <div className="notificationMainHeader">
            {localized("Notifications")}
          </div>
          <div className="notificationSubheader">
            {localized("ReceivedNotifications")}
          </div>
        </div>

        <Divider />
        <div className="notificationOverflow">
          <NotificationList />
        </div>
      </Drawer>
    </div>
  );
};
export default NotificationDrawer;
